<template>
  <div class="seo-header">
    <progressive-background
      :src="hiresImagePath"
      :placeholder="thumbnailImagePath"
      data-test="backgroundImage"
      class="background-image notification background-color"
    >
      <div slot="content">
        <NavTop />
        <div v-if="$apollo.queries.serviceInfo.loading" />
        <div
          v-else
          class="business-details"
        >
          <h1
            class="is-size-1 business-name"
            data-test="businessName"
          >
            {{ serviceInfo.BusinessName }}
          </h1>
          <a
            :href="serviceInfo.Url"
            data-test="businessUrl"
          >{{ serviceInfo.Url }}</a>
          <h1 class="is-size-1">
            {{ $t('seo_service.header.title') }}
          </h1>
          <time
            v-if="serviceInfo.ReportLastCompletedDate"
            :datetime="serviceInfo.ReportLastCompletedDate"
            class="date-text"
          >
            {{ formatDate(date === 'last' ? serviceInfo.ReportLastCompletedDate : date) }}
          </time>
        </div>
      </div>
    </progressive-background>
  </div>
</template>
<script>
import NavTop from '@/components/SeoService/NavTop'
import GET_SERVICE_INFO from '@/graphql/GET_SERVICE_INFO.gql'
import format from 'date-fns/format'
export default {
  name: 'Header',
  components: {
    NavTop
  },

  props: {
    date: {
      type: String,
      default: null
    }
  },

  apollo: {
    serviceInfo: {
      query: GET_SERVICE_INFO,
      variables () {
        return { seoId: this.$route.params.serviceId }
      },
      update: data => data.getSEOReport
    }
  },
  computed: {
    thumbnailImagePath () {
      return require('../../assets/thumbnails/thumb_seo_background.jpg')
    },
    hiresImagePath () {
      return require('../../assets/seo_background_greyscale.jpg')
    }
  },
  methods: {
    formatDate (date) {
      return format(date, '[For the] Do MMM YYYY')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
  .background-image {
    height: 350px;
    width: 100%;
    top: 0;
    left: 0;
    margin-bottom: 25px;
  }

  .business-details {
    margin-left: 30px;
  }
  .business-name, .date-text, .title {
    color: #ffffff;
    text-shadow: 0 0.05rem 0.1rem rgba(0, 0, 0, .5);
  }

  .business-name {
    padding-top: 20px;
  }

  .business-details a {
    color: white;
    text-decoration: none;
  }

  .business-details a:hover {
    color: #227fcf;
  }

  p {
    color: #ffffff;
  }
</style>

<style lang="scss">
@import '../../../sass/_variables.scss';
  .seo-header {
    .progressive-background-slot {
      position: absolute !important;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 15px;

      * {
        position: relative;
      }

      &:before {
        content:'';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        opacity: .6 !important;
        transition: all 5s;
      }
    }

    .background-color .progressive-background-slot:before {
      background-color: var(--tertiary-color-transparent);
    }

    .notification {
      min-height: 150px;
    }

  }

</style>
